<template>
    <div>
        <ul class="list-inline text-warning small mb-0">
            <li class="list-inline-item mx-0">
                <span v-if="rating >= 1" class="fas fa-star"></span>
                <span v-if="rating >= 2" class="fas fa-star"></span>
                <span v-if="rating >= 3" class="fas fa-star"></span>
                <span v-if="rating >= 4" class="fas fa-star"></span>
                <span v-if="rating >= 5" class="fas fa-star"></span>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "StarRating",
        
        props: {
            rating: Number,
            comment: String
        }
    }
</script>

<style scoped>

</style>